import { createI18n } from 'vue-i18n'

import fr_BE from './assets/translations/fr_BE'
import nl_BE from './assets/translations/nl_BE'
import fmShared from './assets/translations/fmShared'
import peppol from './assets/translations/peppol'

const messages = {
  fr_BE,
  nl_BE
}

/** Adds the keys of `extra` that `target` lacks, recursively. */
function mergeMissing(target, extra) {
  for (const [key, value] of Object.entries(extra)) {
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      target[key] ??= {}
      mergeMissing(target[key], value)
    } else if (target[key] === undefined) {
      target[key] = value
    }
  }
}

for (const shared of [fmShared, peppol]) {
  for (const [code, extra] of Object.entries(shared)) {
    mergeMissing(messages[code], extra)
  }
}

// Components shared with Funeral Manager read `enums.yesNo`; Crema's
// translations name it `enums.yes_no`.
for (const locale of Object.values(messages)) {
  if (locale.enums?.yes_no && !locale.enums.yesNo) {
    locale.enums.yesNo = locale.enums.yes_no
  }
}

const i18n = createI18n({
  locale: 'fr_BE',
  fallbackLocale: 'fr_BE',
  messages
})

export default i18n

export { i18n }
